import type { Organization } from './organizationService';
import { getIndustryType } from './organizationService';
import {
  getTaskCategoriesForIndustry,
  mergeTaskCategories,
} from '@/constants/taskCategories';

/**
 * Returns the full list of task categories for an organization:
 * industry default list + org's custom categories, merged and deduped.
 */
export function getTaskCategoriesForOrganization(
  organization: Organization | null | undefined
): string[] {
  const industryType = getIndustryType(organization);
  const industryList = getTaskCategoriesForIndustry(industryType);
  const custom = organization?.customTaskCategories;
  return mergeTaskCategories(industryList, custom);
}
